export const SUPERGRAPH_SCHEMA_ID = 'supergraph';
